// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"20f9508c","479":"e65a875a","512":"e1952441","723":"420ce837","736":"bde27fa4","791":"439cf585","849":"f9d48de2"}[chunkId] + ".chunk.js";
};